module.exports = __webpack_public_path__ + "static/media/Outfit_400Regular.8422587f.ttf";